export default "__VITE_ASSET__CsjQVq9d__"